import {
    CREATE_SIZE_MEASUREMENT_MASTER_REQUEST,
    CREATE_SIZE_MEASUREMENT_MASTER_SUCCESS,
    CREATE_SIZE_MEASUREMENT_MASTER_FAILURE,
    DELETE_SIZE_MEASUREMENT_MASTER_REQUEST,
    DELETE_SIZE_MEASUREMENT_MASTER_SUCCESS,
    DELETE_SIZE_MEASUREMENT_MASTER_FAILURE,
    FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_REQUEST,
    FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_SUCCESS,
    FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_FAILURE,
    FETCH_SIZE_MEASUREMENT_MASTER_REQUEST,
    FETCH_SIZE_MEASUREMENT_MASTER_SUCCESS,
    FETCH_SIZE_MEASUREMENT_MASTER_FAILURE,
    UPDATE_SIZE_MEASUREMENT_MASTER_REQUEST,
    UPDATE_SIZE_MEASUREMENT_MASTER_SUCCESS,
    UPDATE_SIZE_MEASUREMENT_MASTER_FAILURE,
    RESET_SIZE_MEASUREMENT_MASTER_INFO,
    CREATE_SIZE_MEASUREMENT_MASTER_FORM,
    UPDATE_SIZE_MEASUREMENT_MASTER_FORM,
    NAVIGATE_SIZE_MEASUREMENT_DETAILS,
    NAVIGATE_SIZE_MEASUREMENT_MASTER,
    FETCH_ALL_SIZES_SUCCESS,
    FETCH_ALL_BRANDS_SUCCESS,
    FETCH_ALL_STYLE_SUCCESS,
    FETCH_ALL_BUYER_SUCCESS
} from './sizeMeasurementMaster.actionsType';

export const SIZE_MEASUREMENT_MASTER = 'sizeMeasurement';

let initialState = {
    loading: false,
    sizeMeasurement: [],
    sizeList: [],
    styleList: [],
    buyerList: [],
    sizeMeasurementform: {},
    selectedState: {},
    errorMessage: ''
};

export let sizeMeasurementReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_SIZE_MEASUREMENT_MASTER_REQUEST:
        case CREATE_SIZE_MEASUREMENT_MASTER_REQUEST:
        case UPDATE_SIZE_MEASUREMENT_MASTER_REQUEST:
        case FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_REQUEST:
        case DELETE_SIZE_MEASUREMENT_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SIZE_MEASUREMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurement: updatePayload
            };
        case FETCH_ALL_SIZES_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeList: updatePayload
            };
        case FETCH_ALL_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                styleList: updatePayload
            };
        case FETCH_ALL_BUYER_SUCCESS:
            return {
                ...state,
                loading: false,
                buyerList: updatePayload
            };
        case CREATE_SIZE_MEASUREMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurementform: {}
            };
        case UPDATE_SIZE_MEASUREMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurementform: {}
            };
        case FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurementform: payload
            };
        case DELETE_SIZE_MEASUREMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case RESET_SIZE_MEASUREMENT_MASTER_INFO:
            return {
                ...state,
                sizeMeasurementform: {}
            };
        case CREATE_SIZE_MEASUREMENT_MASTER_FORM:
        case UPDATE_SIZE_MEASUREMENT_MASTER_FORM:
            return {
                ...state,
                loading: false,
                sizeMeasurementform: {
                    ...state.sizeMeasurementform,
                    [payload.key]: payload.value
                }
            };
        case NAVIGATE_SIZE_MEASUREMENT_DETAILS:
            return {
                ...state,
                isSizeMeasurementDetails: true,
                singleSizeMeasurement: updatePayload.singleSizeMeasurement
            };
        case NAVIGATE_SIZE_MEASUREMENT_MASTER:
            return {
                ...state,
                isSizeMeasurementDetails: false
            };
        case FETCH_SIZE_MEASUREMENT_MASTER_FAILURE:
        case CREATE_SIZE_MEASUREMENT_MASTER_FAILURE:
        case UPDATE_SIZE_MEASUREMENT_MASTER_FAILURE:
        case FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_FAILURE:
        case DELETE_SIZE_MEASUREMENT_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
